import { useEffect } from "react";

/**
 * Hook para definir o título da página. O título por padrão terá o final `" | Fynd Clientes"` acrescentado.
 *
 * @param title Título para a página.
 * @param deps Dependências do `useEffect`. Se informado, o título será atualizado apenas quando há mudanças nas dependências.
 * @param excludeSuffix Opção para excluir o sufixo `" | Fynd Clientes"`.
 */
export default function useTitle(
  title: string,
  deps: any[] = [],
  excludeSuffix?: boolean
) {
  useEffect(() => {
    const previousTitle = document.title;

    document.title = `${title}${!excludeSuffix ? " | Fynd Clientes" : ""}`;

    return () => {
      document.title = previousTitle;
    };
  }, deps);
}
